module.exports = __webpack_public_path__ + "img/logo.e9728e8e.png";